var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8969 21.968C12.3662 21.9696 11.8569 21.7585 11.4829 21.382L3.64589 13.547C3.23236 13.1349 3.02036 12.5621 3.06589 11.98L3.56589 5.41401C3.63731 4.42569 4.42531 3.64068 5.41389 3.57301L11.9799 3.07301C12.0319 3.06201 12.0829 3.06201 12.1349 3.06201C12.6645 3.06138 13.1725 3.27234 13.5459 3.64801L21.3829 11.482C21.7581 11.8571 21.969 12.3659 21.969 12.8965C21.969 13.4271 21.7581 13.9359 21.3829 14.311L14.3109 21.382C13.9367 21.7583 13.4276 21.9693 12.8969 21.968ZM8.65389 6.65401C7.74871 6.65427 6.95655 7.26245 6.72249 8.13684C6.48842 9.01123 6.87081 9.93383 7.6548 10.3863C8.4388 10.8387 9.42893 10.7082 10.0689 10.068L10.0759 10.062L10.0829 10.055L10.0749 10.062C10.6433 9.48857 10.8112 8.62957 10.5005 7.88432C10.1897 7.13907 9.46133 6.65377 8.65389 6.65401Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.350c7986.svg";
export { ForwardRef as ReactComponent };